import { HttpStatusCode } from "axios";
import FreshmanMainStepService from "../../apiServices/freshman/mainstepService"
import { alertConstants } from "../../helper/sweet-alert";
import { IMainStepData } from "../../models/freshman/mainStep";
import { setKeyValuePair, setMainStep, setMainSteps } from "../../store/slices/freshman/mainStepSlice";


export function getMainStep(id: number) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.getMainStep(id);
    if (response?.success === true) {
      dispatch(setMainStep(response.data));
    } else {
      console.log("error");
    }
  };
}

export function getAllMainSteps(includeInactive?: boolean) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.getAllMainSteps(includeInactive);
    if (response?.success === true) {
      dispatch(setMainSteps(response.data));
    } else {
      console.log("error");
    }
  };
}

export function createMainStep(data: IMainStepData, callback: Function) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.createMainStep(data);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function updateMainStep(
  data: IMainStepData,
  id: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.updateMainStep(data, id);
    if (response?.success === true) {
      callback(alertConstants.success);
    } else {
      if (response.status === HttpStatusCode.Conflict) {
        callback(alertConstants.conflict);
      } else {
        callback(alertConstants.error);
      }
    }
  };
}

export function inactiveMainStep(
  id: number,
  callback: Function
) {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.inactiveMainStep(id);
    if (response === true) {
      callback(alertConstants.inactiveSuccess);
    } else {
      callback(alertConstants.inactiveFailure);
    }
  };
}

export function getAllMainStepsKeyValuePair() {
  return async function (dispatch: any, getState: any) {
    let response = await FreshmanMainStepService.getAllMainStepsKeyValuePair();
    if (response?.success === true) {
      dispatch(setKeyValuePair(response.data));
    } else {
      console.log("error");
    }
  };
}